import './modal.scss';
import OutsideAlerter from '../outsideClicker';
export default function Modal({content,setOpen}){
	return (
		<div className="modal-wrap">
			<OutsideAlerter className="modal" callback={setOpen ? ()=>{setOpen(false)}:null}>
				<div className="modal-header">
					<svg className="me-3" width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6 17C6.828 17 7.5 17.672 7.5 18.5C7.5 19.328 6.828 20 6 20C5.172 20 4.5 19.328 4.5 18.5C4.5 17.672 5.172 17 6 17ZM6 0C9.314 0 12 2.686 12 6C12 8.165 11.247 9.29 9.326 10.923C7.399 12.56 7 13.297 7 15H5C5 12.526 5.787 11.305 8.031 9.399C9.548 8.11 10 7.434 10 6C10 3.79 8.21 2 6 2C3.79 2 2 3.79 2 6V7H0V6C0 2.686 2.686 0 6 0Z" fill="currentColor"/>
						</svg>

						Pagalba
				</div>
				<div className="modal-content" dangerouslySetInnerHTML={{__html:content}}></div>
				<div className="modal-footer" style={{textAlign:'center'}}>
					<button type="button" className="btn btn-secondary" onClick={()=>{setOpen && setOpen(false)}}>
						Uždaryti
					</button>
				</div>
			</OutsideAlerter>
		</div>
	)
}